import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * Wraps company-only routes. If the company account is not yet active (pending,
 * approved-but-unpaid, past_due, or canceled), redirects to /dashboard where the
 * activation banner and request form are shown.
 *
 * Grandfathered companies (plan_limits === null) and super_user impersonators pass through.
 */
export default function ActiveCompanyRoute({ children }) {
  const { user } = useAuth();

  if (!user) return null;

  const billing = user?.company_billing;

  // Billing not yet populated — hold rendering to avoid a white flash before the
  // redirect fires. CompanyBillingBanner triggers a checkAuth() re-fetch if billing
  // is missing, so this state resolves quickly.
  if (!billing && (user.role === "company" || user.role === "company_employee")) {
    return <div className="p-12 font-mono text-sm text-muted-foreground">Loading…</div>;
  }

  const status = billing?.company_status;

  // Active companies (and grandfathered/no-status) pass through.
  if (!status || status === "active") return children;

  return <Navigate to="/dashboard" replace />;
}
